
var _mfw_count = 0;
function MobileFullWidth($container, params) {
    if($container === undefined) {
        console.warn("Parameter missing \"new MobileFullWidth($container)\"");
        return false;
    }
    var $ = jQuery;
    var _this = this;
    _this.initDone = false;
    this.$container = $container;
    this.$image = $container.find("img");
    this.params = {
        centerX: 50,
        centerY: 50,
        containerHeight: "auto",
        maxWidth: 767,
        width: "767px",
        fit: 'container',
        responsive: {
        }
    };

    $.extend(this.params, this.$container.data());
    $.extend(this.params, params);

    this.init = function() {
        _mfw_count++;
        // Turn off event if already exists
        if(typeof _this.$container.data('IFW') !== 'undefined') {
            _this.$container.data('IFW').off();
        }
        this.$container.data('IFW', _this);
        _this.defaultParams = jQuery.extend(true, {}, _this.params);
        this.id = _mfw_count;

        _this.$image.css({
            "width": _this.params.width,
            "position": "relative"
        });

        if(_this.params.fit === 'container') {
            this.$container.parent().css('overflow', 'hidden');
        }

        $(window).on("resize.full-width-"+this.id, _this.resize);

        if(!_this.initDone) {
            $(window).trigger("resize.full-width-"+_this.id);
        }

        this.imageLoad();



    };

    this.imageLoad = function() {
        // Kazkodel nepasitikiu on load eventu
        _this.loadingInterval = setInterval(function () {
            if(_this.$image[0].naturalWidth > 0 && _this.$image[0].naturalHeight) {
                $(window).trigger("resize.full-width-"+_this.id);
                clearInterval(_this.loadingInterval);
            }
        }, 100);

        // _this.$image.on('load', function () {
        //     if(_this.$image[0].complete && _this.$image[0].naturalWidth > 0) {
        //         $(window).trigger("resize.full-width-"+_this.id);
        //         clearInterval(_this.loadingInterval);
        //     }
        // });
    };

    this.setOffset = function () {
        _this.$image.css(
            {
                "top": 0,
                "left": 0,
                "width": _this.params.width
            }
        );

        var containerSize = {x: _this.$container.outerWidth(), y: _this.$container.outerHeight()};
        var imageSize = {x: _this.$image.outerWidth(), y: _this.$image.outerHeight()};

        var containerCenter = {x: containerSize.x/2, y: containerSize.y/2};

        var imageAspectRatio = imageSize.y/imageSize.x;

        imageSize.x = imageSize.x < containerSize.x ? containerSize.x : imageSize.x;
        imageSize.y = imageSize.x*imageAspectRatio;
        imageSize.x = imageSize.y < containerSize.y ? containerSize.y/imageAspectRatio : imageSize.x;
        imageSize.y = imageSize.x*imageAspectRatio;

        var imageCenter = {x: imageSize.x*_this.params.centerX/100, y:imageSize.y*_this.params.centerY/100};
        var offset = {x:containerCenter.x-imageCenter.x, y:containerCenter.y-imageCenter.y};

        offset.x = offset.x+imageSize.x < containerSize.x ? (_this.params.centerX >= 50 ? offset.x+(containerSize.x-(offset.x+imageSize.x)) : 0) : offset.x;

        offset.x = offset.x > 0 ? 0 : offset.x;

        offset.y = offset.y+imageSize.y < containerSize.y ? (_this.params.centerY >= 50 ? offset.y+(containerSize.y-(offset.y+imageSize.y)) : 0) : offset.y;
        offset.y = offset.y > 0 ? 0 : offset.y;


        offset.x = imageSize.x < containerSize.x ? 0 : offset.x;


        _this.$image.css(
            {
                "top": offset.y,
                "left": offset.x,
                "width": imageSize.x
            }
        );
    };

    this.resize = function (e) {

        // only if window width changes
        if(_this._ksLastWidth === window.innerWidth) {
            return;
        }


        if(_this.initDone === true) {
            _this._ksLastWidth = window.innerWidth;
            _this.$container.addClass('positioned');
        }

        if(window.innerWidth <= _this.params.maxWidth) {


            var responsive_matches = [];
            $.each(_this.defaultParams.responsive, function (k, v) {
                var width = parseInt(k);
                if(window.innerWidth < width) {
                    responsive_matches.push(width);
                }
            });
            if(responsive_matches.length > 0) {
                $.extend(_this.params, _this.defaultParams.responsive[Math.min.apply(null, responsive_matches)]);
            }
            else {
                $.extend(_this.params, _this.defaultParams);
            }

            _this.$image.css({
                "position": "relative"
            });
            _this.$container.css({
                "position": "relative",
                "left": 0,
                "max-height": _this.params.containerHeight,
                "height": _this.params._containerHeight
            });
            var width = '100%';
            var offset_left = 0;
            if(_this.params.fit === 'window') {
                width = window.innerWidth;
                offset_left = -_this.$container.offset().left;
            }
            _this.$container.css({
                "width": width,
                "left": offset_left
            });

            _this.setOffset();
        }
        else {
            _this.$image.css({
                "width": "",
                "position": "",
                "top": "",
                "left": ""
            });
            _this.$container.css({
                "width": "",
                "position": "",
                "left": "",
                "max-height": ""
            });
        }
        _this.initDone = true;
    };

    this.getDimensionType = function(string) {
        var regex = /^([-\d\.]*)([^-\d\.]+)?$/g;
        var m;
        var response = '';
        while ((m = regex.exec(string)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            switch (m[2]) {
                case "%":
                response = 'percent';
                break;
                case "px":
                response = 'pixel';
                break;
                default:
                response = 'pixel';
                break;
            }
        }
        return response;
    };

    this.off = function() {
        $(window).off("resize.full-width-"+this.id);
    };

    this.init();
}
